const allowedProtocols = new Set(["http:", "https:", "mailto:", "tel:"])
const protocolPattern = /^[a-z][a-z\d+.-]*:/i

export const normalizeHref = (href) => {
    if (href === null || href === undefined) return undefined

    const hrefString = String(href).trim()

    if (!hrefString) return undefined

    if (hrefString.startsWith("//")) return undefined

    if (hrefString.startsWith("/") || hrefString.startsWith("#")) {
        return hrefString
    }

    if (protocolPattern.test(hrefString)) {
        try {
            return allowedProtocols.has(new URL(hrefString).protocol)
                ? hrefString
                : undefined
        } catch {
            return undefined
        }
    }

    return `https://${hrefString}`
}
